
const { useSelector } = require("react-redux")

const RenderWithPermissions = ({children, permissions}) => {
    const authData = useSelector(s => s.auth.data);
    const userPermissions = authData.permissions

    let allowToRender = false;
    
    if (!permissions) {
        throw new Error('Invalid Permission Params');
    }

    if (Array.isArray(permissions)) {
        allowToRender = permissions.some(p => userPermissions.some(up => p===up));
    } else {
        allowToRender = userPermissions.includes(permissions);
    }

    if (allowToRender) {
        return children;
    }
    return null;
}

export default RenderWithPermissions;